import { Model } from "../mvvm/Model.js";
/** Session is an OOP model of the current authenticated state. */
export class Session extends Model {
    tokens;
    role;
    userId;
    constructor(tokens, role, userId) {
        super();
        this.tokens = tokens;
        this.role = role;
        this.userId = userId;
    }
    static anonymous() {
        return new Session(null, null, null);
    }
    get isAuthenticated() {
        return this.tokens !== null;
    }
    get isAdmin() {
        return this.role === "admin";
    }
    validate() {
        if (this.tokens && !this.userId)
            return ["authenticated session must have a user id"];
        return [];
    }
}
//# sourceMappingURL=Session.js.map